import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {NbIconModule} from '@nebular/theme';

import {SupportBoxComponent} from './support.component';

@NgModule({
  declarations: [SupportBoxComponent],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    NbIconModule
  ],
  exports: [SupportBoxComponent]
})
export class SupportBoxModule {

}
